// This will save alert data to be shown across routes.
// The object will scoped by field so there shouldn't be conflicts
export const addAlertData = ({ data, field }) => ({
  type: 'ADMIN_ALERT_ADD',
  field,
  data
});

export const removeAlertData = (field) => ({
  type: 'ADMIN_ALERT_REMOVE',
  field
});
